<template>

      <v-row no-gutters style="height: 100%">
        <v-col
       class="d-none d-sm-flex"
      cols="12"
      sm="5"
     >
     <div id="hero" class="pa-4">
        <v-toolbar flat style="background: none;">
          <img :src="$store.state.applogo" width="40px"/>
      </v-toolbar>

      <div class="mt-10 pa-10 font-weight-light" >
          <span class="info px-2" style="color:#fff; font-size: 1.8em;">ACCURACY DELIVERED, PEACE OF MIND GUARANTEED.</span>
          <p style="color:#fff; font-size: 1.4em;" class="mt-8">
            ZERA is a complete SOLUTION for managing your business.
            From Service/Product Inventory, Sales, Cashflow to Tax filling platform... 
            <span class="info px-3">Here, we make things simple</span>
          </p>
        </div>
      
     </div>
    </v-col>
     <v-col
      cols="12"
       sm="7"
     >
     <v-toolbar flat>
      <v-spacer></v-spacer>
      <!-- <span class="">Don't have an account?</span>
      <v-btn class="ml-4" small elevation="0" color="info">CREATE NOW</v-btn> -->
     </v-toolbar>
            <v-form
                ref="form"
                style="width: 370px; margin:auto;"
                v-model="valid"
                lazy-validation
              >
            <v-card style="margin-top: 12%; background: none;" class="pa-2 elevation-0 animate__animated animate__fadeInLeft">
              <p class="text-center pt-5">
              <img :src="$store.state.systemlogo" width="180px"/>
              </p>
              <v-card-text>
                      <v-text-field
                        v-model="username"
                          :rules="nameRules"
                        label="Username"
                        required
                      x-large
                      ></v-text-field>
                   
                      <v-text-field
                      x-large
                        v-model="password"
                        :rules="nameRules"
                        label="Password"
                        type="password"
                        v-on:keyup.enter="validate()"
                        required
                        
                      ></v-text-field>
                      <div style="height: 40px;">
                      <span style="float: left;"><v-checkbox dense hide-details label="Show Password"></v-checkbox></span>
                      <span style="float: right; margin-top: 7px;"><a>Forgot Password?</a></span>
                    </div>
                     
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <div style="width: 160px">
                  <v-btn
                        color="primary"
                        block
                        tile
                        x-large
                        :loading="loading"
                        @click="loading=true,validate()"
                      >
                        SIGN IN
                      </v-btn>
                </div>
                  
                      <v-spacer/>
              </v-card-actions>
            </v-card>

          </v-form>
     </v-col>
   </v-row>

</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      valid: true,
      username: '',
      emailRules: [
        v => !!v || 'Please enter your email!'
      ],
      nameRules: [
        v => !!v || 'Please enter your password!'
      ],
      password: '',
      loading: false,
      snackbar: false,
    }),
    created() {
      if (this.$session.exists()) {
          this.setLoggedIn(false)
          this.$session.destroy()
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      
      validate () {
        this.loading=false
        if (this.$refs.form.validate()) {
          this.login()
        }
      },
      login(){
        this.loading = true
         var param = {
            Username: this.username,
            Password: this.password,
          }
          this.$http.post("user/login",param).then(response => {
            this.loading = false
          if(response.data.status == true) {
            this.$session.start()
            this.$session.set('jwt', response.data.account.token)
            this.$session.set('username', response.data.account.username)
            this.$session.set('role', response.data.account.role)
            this.$session.set('account', response.data.account)
            this.$session.set('userID', response.data.account.id)
             this.$session.set('fullname', response.data.account.fullname)
            this.$session.set('title', response.data.account.title)
            this.setAlertColor('success')
              
              setTimeout(()=>{
                this.loading=false
                this.$router.push('/dashboard')
              }, 700)
               
            
          } else {
            this.setAlertColor('error')
            this.setLoggedIn(false)
             this.loading=false
          }
            this.setAlertText(response.data.message)
            this.setAlert(true)
          }).catch(e => {
           console.log(e)
         })
        
          
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>